import { List, Record } from 'immutable'

import ActionTypes from '../constants/action-types'
import AvailableDataIntegration from '../model/availableDataIntegration'
import { ReducerAction } from '../utils/reducer-utils'

export interface AvailableDataIntegrationReducer {
  companyID: string | undefined
  loading: boolean
  loaded: boolean
  availableDataIntegrations: List<AvailableDataIntegration>
  error: Error | null
}

const Params = Record<AvailableDataIntegrationReducer>({
  companyID: undefined, // keeping track of the active company by listening on COMPANY_SETTING_ACTIVE
  loading: false,
  loaded: false,
  availableDataIntegrations: List<AvailableDataIntegration>(),
  error: null,
})

export interface AvailableDataIntegrationAction extends ReducerAction {
  companyID?: string
  availableDataIntegrations?: AvailableDataIntegration[]
}

export default (
  state: Record<AvailableDataIntegrationReducer> = Params(),
  action: AvailableDataIntegrationAction = { type: '' }
): Record<AvailableDataIntegrationReducer> => {
  // keep track of the active company
  if (action.type === ActionTypes.COMPANIES_SETTING_ACTIVE || action.type === ActionTypes.COMPANIES_LOADED) {
    return Params({
      companyID: action.companyID,
    })
  }
  // only process actions for the active company
  if (action.companyID && state.get('companyID') && action.companyID !== state.get('companyID')) {
    return state
  }

  switch (action.type) {
    case ActionTypes.AVAILABLE_DATA_INTEGRATIONS_LOADING:
      return Params({
        companyID: state.get('companyID'),
        loading: true,
      })
    case ActionTypes.AVAILABLE_DATA_INTEGRATIONS_LOADED:
      return Params({
        companyID: state.get('companyID'),
        loaded: true,
        availableDataIntegrations: List<AvailableDataIntegration>(action.availableDataIntegrations),
      })
    case ActionTypes.AVAILABLE_DATA_INTEGRATIONS_LOAD_FAILED:
      return Params({
        companyID: state.get('companyID'),
        error: action.error,
      })
    case ActionTypes.USER_LOGGED_OUT:
      return Params()
    default:
      return state
  }
}
